class Storage {
    storedValues = {};
    get values() {
        return this.storedValues;
    }
    set(key, value, type = 'local') {
        return this.writeValue(type, key, value);
    }
    get(key, type = 'local') {
        return this.getValue(type, key);
    }
    remove(key, type = 'local') {
        return this.removeValue(type, key);
    }
    has(key, type = 'local') {
        if (type === 'variable') {
            return Boolean(this.storedValues[key]);
        }
        return !!this.storage(type).getItem(key);
    }
    writeValue(type, key, value) {
        if (type === 'variable') {
            this.storedValues[key] = value;
            return;
        }
        let preparedValue = value;
        if (typeof preparedValue !== 'string') {
            preparedValue = JSON.stringify(preparedValue);
        }
        return this.storage(type).setItem(key, preparedValue);
    }
    getValue(type, key) {
        const value = type === 'variable' ? this.storedValues[key] : this.storage(type).getItem(key);
        if (!value) {
            return null;
        }
        try {
            return JSON.parse(value);
        }
        catch (e) {
            return value;
        }
    }
    removeValue(type, key) {
        if (type === 'variable') {
            if (!this.storedValues[key]) {
                return;
            }
            delete this.storedValues[key];
            return;
        }
        return this.storage(type).removeItem(key);
    }
    storage(type) {
        if (type === 'session') {
            return sessionStorage;
        }
        return localStorage;
    }
    clear() {
        this.storedValues = {};
    }
}
export const storageAPI = new Storage();
